import Vue from 'vue';
import vueCropper from 'vue-cropper';
// documentation
// https://github.com/xyxiao001/vue-cropper/blob/master/english.md

Vue.use(vueCropper);
